
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Controlador as ControladorBusqueda } from '../../controlador-cursos';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        public get ControladorPrincipal() { return Model; }
        public get Controlador() { return ControladorBusqueda; }
        public get Buscador() { return ControladorBusqueda.Buscador; }
        public get Filtros() { return this.Buscador.Filtros; }

        public Estado: string = '';
        public SubModo: string = '';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Estado = this.Buscador.Estado;
            this.Eventos.push( this.Buscador.onEstado.subscribe( () => this.Estado = this.Buscador.Estado ) );
            this.Eventos.push( this.ControladorPrincipal.Vista.onSubModo.subscribe( () => this.SubModo = this.ControladorPrincipal.Vista.SubModo ) );
            //this.Eventos.push( this.Buscador.onActualizar.subscribe( this.Iniciar ) );
        }



    }
